import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import * as FiIcons from "react-icons/fi";
import { Flex, Text, Spinner, Button } from "@chakra-ui/react";
import Table from "../components/Table";
import GButton from "../../../../components/ui/button/Button";
import CreateModal from "../components/modals/CreateModal";
import CreateBulkModal from "../components/modals/CreateBulkModal";
import ImportModal from "../components/modals/ImportModal";
import ExportModal from "components/ui/modal/ExportModal";
import FilterModal from "../components/modals/FilterModal";
import BreadCrumb from "components/ui/breadcrumb/BreadCrumb";
import { getCoupons, resetFilteredData } from "../services/couponsService";
import { IoCloseOutline } from "react-icons/io5";
import CryptoJS from 'crypto-js';
import NotAuthorizedCompo from "components/ui/NotAuthorizedCompo/NotAuthorizedCompo";
import { checkIdExists } from "utils/cheackAuth"
import useDecryptedPrivilege from "hooks/useDecryptedPrivilege ";


const Coupons = () => {
  const retrievedArray =useDecryptedPrivilege()
  const ManageBranches = checkIdExists(retrievedArray, 40);

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const coupons = useSelector((state) => state.coupons);
  const filteredCoupons = useSelector((state) => state.coupons);

  const [showCreateCouponModal, setShowCreateCouponModal] = useState(null);
  const [showCreateBulkCouponModal, setShowCreateBulkCouponModal] =
    useState(null);
  const [showImportCouponsModal, setShowImportCouponsModal] = useState(null);
  const [exportModal, SetExportModal] = useState(false);
  const [showFilterCouponsModal, setShowFilterCouponsModal] = useState(null);
  const [TableStatus, setTableStatus] = useState("all");

  useEffect(() => {
    dispatch(getCoupons());
  }, [dispatch]);

  const resetFunction = () => {
    dispatch(resetFilteredData());
  };

  if(ManageBranches===false  ){
    return(
      <NotAuthorizedCompo/>
    )
  }

  return (
    <>
      <BreadCrumb>
        <Flex
          alignItems="center"
          justifyContent="space-between"
          gap={4}
          flexWrap="wrap"
        >
          <Text fontSize="1.2rem" color="dark" textTransform="capitalize">
            {t("pages.coupons.coupons")}
          </Text>

          <Flex gap={2} flexWrap="wrap">
            <Button
              type="button"
              bg="none"
              border="1px solid"
              borderColor="border"
              textTransform="capitalize"
              fontSize="1rem"
              color="text"
              _hover={{ bg: "primary", color: "light" }}
            >
              <div onClick={() => SetExportModal(true)}>
                {t("general.export")}
              </div>
            </Button>
            <GButton
              title={t("pages.coupons.create_bulk_coupon")}
              onClick={() => setShowCreateBulkCouponModal(true)}
              bg="primary"
              color="light"
              border="1px solid transparent"
              hover={{ bg: "none", borderColor: "primary", color: "primary" }}
            />
            <GButton
              title={t("pages.coupons.create_coupon")}
              onClick={() => setShowCreateCouponModal(true)}
              bg="primary"
              color="light"
              border="1px solid transparent"
              hover={{ bg: "none", borderColor: "primary", color: "primary" }}
            />
          </Flex>
        </Flex>
      </BreadCrumb>

      <Flex
        flexWrap="wrap"
        justifyContent="space-between"
        paddingBlock={2}
        p={4}
        borderBottom="1px solid"
        borderColor="border"
        bg="light"
        gap={2}
      >
        <Flex
          alignItems="center"
          flexWrap="wrap"
          textTransform="capitalize"
          gap={4}
          color="text"
          bg="light"
        >
          <GButton
            title={t("general.all")}
            bg="none"
            color={TableStatus === "all" ? "primary" : "text"}
            isDisabled={false}
            borderRadius={0}
            borderBottom={TableStatus === "all" ? "2px solid" : "none"}
            borderColor="primary"
            onClick={() => setTableStatus("all")}
          />

          <GButton
            title={t("general.active")}
            bg="none"
            color={TableStatus === "active" ? "primary" : "text"}
            isDisabled={false}
            borderRadius={0}
            borderBottom={TableStatus === "active" ? "2px solid" : "none"}
            borderColor="primary"
            onClick={() => setTableStatus("active")}
          />

          <GButton
            title={t("general.inactive")}
            bg="none"
            color={TableStatus === "inactive" ? "primary" : "text"}
            isDisabled={false}
            borderRadius={0}
            borderBottom={TableStatus === "inactive" ? "2px solid" : "none"}
            borderColor="primary"
            onClick={() => setTableStatus("inactive")}
          />

          <GButton
            title={t("general.deleted")}
            bg="none"
            color={TableStatus === "deleted" ? "primary" : "text"}
            isDisabled={false}
            borderRadius={0}
            borderBottom={TableStatus === "deleted" ? "2px solid" : "none"}
            borderColor="primary"
            onClick={() => setTableStatus("deleted")}
          />
        </Flex>

        <GButton
          title={
            filteredCoupons.filteredData.length === 0
              ? t("general.filter")
              : t("general.clear_filter")
          }
          border="1px solid"
          borderColor="border"
          postfixElement={
            filteredCoupons.filteredData.length === 0 ? (
              <FiIcons.FiFilter size={16} />
            ) : (
              <IoCloseOutline fontWeight={800} size={20} />
            )
          }
          hover={{ bg: "primary", borderColor: "primary", color: "light" }}
          onClick={
            filteredCoupons.filteredData.length === 0
              ? () => setShowFilterCouponsModal(true)
              : resetFunction
          }
        />
      </Flex>

      {coupons.isLoading ? (
        <Flex bg="light" p={4} justifyContent="center">
          <Spinner />
        </Flex>
      ) : (
        <Table
          coupons={coupons.data}
          couponsSelectedTable={TableStatus}
          onClickCreateCouponBtn={() => setShowCreateCouponModal(true)}
        />
      )}

      {showCreateCouponModal && (
        <CreateModal onClose={() => setShowCreateCouponModal(null)} />
      )}

      {showCreateBulkCouponModal && (
        <CreateBulkModal onClose={() => setShowCreateBulkCouponModal(null)} />
      )}

      {showImportCouponsModal && (
        <ImportModal onClose={() => setShowImportCouponsModal(null)} />
      )}

      {exportModal && (
        <ExportModal
          onClose={() => SetExportModal(false)}
          data={
            TableStatus === "deleted"
              ? coupons.data.filter((el) => el.IsDeleted === true)
              : TableStatus === "active"
              ? coupons.data.filter((el) => el.IsActive === true)
              : TableStatus === "inactive"
              ? coupons.data.filter((el) => el.IsActive === false)
              : TableStatus === "all"
              ? coupons.data.filter((el) => el.IsDeleted === false)
              : []
          }
          fileName={
            TableStatus === "deleted"
              ? "Deleted Coupons"
              : TableStatus === "active"
              ? "Active Coupons"
              : TableStatus === "inactive"
              ? "Inactive Coupons"
              : "All Coupons"
          }
        ></ExportModal>
      )}

      {showFilterCouponsModal && (
        <FilterModal
          onClose={() => setShowFilterCouponsModal(null)}
          data={coupons.data}
        />
      )}
    </>
  );
};

export default Coupons;
